module.exports = __webpack_public_path__ + "static/media/bg-airbnb.676c7a76.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/dummy-images/bg-airbnb.jpeg
// module id = ./src/CSS/assets-minified/dummy-images/bg-airbnb.jpeg
// module chunks = 0